Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Vimeo", {
  enumerable: true,
  get: function get() {
    return _vimeo.Vimeo;
  }
});
var _vimeo = require("./vimeo");